<template>
  <div class="news_detail_page">
    <!-- 面包屑导航 -->
    <div class="breadcrumb_section">
      <div class="breadcrumb_content">
        <span @click="$router.push('/')">{{ $t("Home") }}</span>
        <span class="separator">></span>
        <span @click="$router.push('/News')">{{ $t("News") }}</span>
        <span class="separator">></span>
        <span class="current">{{ getLocalizedField(Detail, 'title') }}</span>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="main_content_section">
      <div class="main_content_wrapper">
        <!-- 左侧文章详情 -->
        <div class="article_detail">
          <p class="detail_title">
            {{ getLocalizedField(Detail, 'title') }}
          </p>
          <p class="detail_meta">
            <span class="detail_time">{{ Detail.publishDate }}</span>
          </p>
          <div
            class="detail_content"
            v-html="getLocalizedField(Detail, 'content')"
          ></div>

          <!-- 社交分享和导航按钮 -->
          <div class="article_footer">
            <div class="social_share">
              <a v-if="Detail.wxUrl" :href="Detail.wxUrl" target="_blank" class="social_link">
                <img src="../../static/img/news_wx_icon.png" class="social_icon" />
              </a>
              <a v-if="Detail.fbUrl" :href="Detail.fbUrl" target="_blank" class="social_link">
                <img src="../../static/img/news_fb_icon.png" class="social_icon" />
              </a>
              <a v-if="Detail.inUrl" :href="Detail.inUrl" target="_blank" class="social_link">
                <img src="../../static/img/news_in_icon.png" class="social_icon" />
              </a>
            </div>
            <div class="navigation_buttons">
              <el-button
                class="nav_button"
                @click="goPrve"
                v-if="hasPrev"
              >
                < {{ $t("Previous") }}
              </el-button>
              <el-button
                class="nav_button"
                @click="goNext"
                v-if="hasNext"
              >
                {{ $t("Next") }} >
              </el-button>
            </div>
          </div>
        </div>

        <!-- 右侧最新新闻 -->
        <div class="latest_news_sidebar">
          <p class="h3">{{ $t("Latest News") }}</p>
          <div class="news_list">
            <div
              class="news_item"
              :class="{ 'first-item': index === 0 }"
              v-for="(item, index) in latestNews"
              :key="index"
              @click="goToNews(item.id)"
            >
              <template v-if="index === 0">
                <div class="news_image">
                  <img v-if="item.image" :src="item.image" :alt="getLocalizedField(item, 'title')" />
                  <div v-else class="image_placeholder"></div>
                </div>
                <div class="news_info">
                  <p class="news_title">{{ getLocalizedField(item, 'title') }}</p>
                  <p class="news_date">{{ item.publishDate }}</p>
                </div>
              </template>
              <template v-else>
                <div class="news_info news_info_only_title">
                  <p class="news_title">{{ getLocalizedField(item, 'title') }}</p>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
import * as API from "@/api/index";
import {getNewsCompanyInfo, getNewsCompanyList} from "../api";
export default {
  components: {},
  data() {
    return {
      Detail: "",
      list: "",
      latestNews: [],
      hasPrev: false,
      hasNext: false,
    };
  },
  watch: {
    $route(to, from) {
      //   console.log(to.path);
      if (to.path.indexOf("/NewsDetail") != -1) {
        window.scrollTo(0, 0);
        this.getList();
      }
      //   var param = this.$route.query.param;
      //   this.path = param;
      //   console.log("param:" + param);
      //   this.navtoPartPath(this.path);
    },
  },
  created() {},
  computed: {},
  mounted() {
    window.scrollTo(0, 0);
    this.getList();
  },
  methods: {
    // 获取多语言字段
    getLocalizedField(item, field) {
      if (!item) return '';
      if (this.$i18n.locale === 'zh') {
        return item[field + 'Cn'] || item[field];
      } else if (this.$i18n.locale === 'es') {
        return item[field + 'Es'] || item[field + 'En'] || item[field + 'Cn'] || item[field];
      }
      return item[field + 'En'] || item[field + 'Cn'] || item[field];
    },
    getList() {
      var data = {
        page: 1,
        limit: 999,
      };
      API.getNewsCompanyList(data)
        .then((res) => {
          var status = res.code;
          if (status === 0) {
            this.list = res.page.list;
            // 获取最新的4条新闻用于侧边栏，并添加多语言字段
            this.latestNews = res.page.list.slice(0, 4).map(item => ({
              ...item,
              // 确保有image字段
              image: item.image
            }));
            this.getDetail();
          }
        })
        .catch(() => {});
    },
    goToNews(id) {
      this.$router.push("/NewsDetail/id=" + id);
    },
    goNext() {
      let news_id = window.location.href.split("id=")[1];
      var next_id = "";
      for (var i = 0; i < this.list.length; i++) {
        var item = this.list[i];
        if (item.id == news_id && i + 1 < this.list.length) {
          next_id = this.list[i + 1].id;
          break;
        }
      }
      console.log("goNext");
      if (next_id != "") this.$router.push("/NewsDetail/id=" + next_id);
    },
    goPrve() {
      let news_id = window.location.href.split("id=")[1];
      var next_id = "";
      for (var i = 0; i < this.list.length; i++) {
        var item = this.list[i];
        if (i > 0 && item.id == news_id) {
          next_id = this.list[i - 1].id;
          break;
        }
      }
      console.log("goPrve");
      if (next_id != "") this.$router.push("/NewsDetail/id=" + next_id);
    },
    getDetail() {
      let news_id = window.location.href.split("id=")[1];
      API.getNewsCompanyInfo(news_id)
        .then((res) => {
          console.log(res);
          var status = res.code;
          if (status === 0) {
            this.Detail = res.newsCompany;
          }

          for (var i = 0; i < this.list.length; i++) {
            var item = this.list[i];
            if (item.id == news_id) {
              if (i > 0) {
                this.hasPrev = true;
              } else {
                this.hasPrev = false;
              }
              if (i < this.list.length - 1) {
                this.hasNext = true;
              } else {
                this.hasNext = false;
              }
              break;
            }
          }
        })
        .catch(() => {});
    },
    goback() {
      // this.$router.back();
      this.$router.push("/News");
    },
  },
};
</script>
  <style lang="scss" scoped>
.news_detail_page {
  background: #fff;
  //min-height: 100vh;
}

// 面包屑导航
.breadcrumb_section {
  background: white;
  padding: 3rem 0 0;
  width: 50%;
  margin-left:12.5%;

  .breadcrumb_content {
    max-width: 140rem;
    margin: 0 auto;
    padding: 0;
    font-size: 1.8rem;
    color: #BDC0C5;
    text-align: left;
    font-family: regular;

    span {
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: #1d2087;
      }

      &.separator {
        margin: 0 1rem;
        color: #BDC0C5;
        cursor: default;
      }

      &.current {
        color: #1D2087;
        cursor: default;
      }
    }
  }
}

// 主要内容区域
.main_content_section {
  padding: 13rem 0 26rem;

  .main_content_wrapper {
    margin: 0 12.5%;
    padding: 0;
    display: flex;
    gap: 4rem;
    align-items: flex-start;
  }
}

// 左侧文章详情
.article_detail {
  flex: 1;
  background: white;
  padding: 0;
  border-radius: 0.5rem;

  .detail_title {
    font-family: bold;
    font-size: 3.2rem;
    color: #212121;
    line-height: 3.5rem;
    margin: 0 0 2rem;
    text-align: left;
  }

  .detail_meta {
    display: flex;
    align-items: center;
    gap: 2rem;
    margin-bottom: 3rem;
    justify-content: flex-start;
    //padding-bottom: 2rem;
    //border-bottom: 1px solid #e0e0e0;

    .detail_type {
      font-size: 1.4rem;
      color: $textRedColor;
      background: $colorF6F6F7;
      padding: 0.4rem 1.2rem;
      border-radius: 0.3rem;
    }

    .detail_time {
      font-size: 1.6rem;
      font-family: light;
      color: #8A9099;
    }
  }

  /deep/ .detail_content {
    font-size: 1.8rem;
    line-height: 3rem;
    color: #838383;
    margin-bottom: 6rem;
    font-family: light;

    p {
      color: #838383;
      font-family: light;
      font-size: 1.8rem;
      line-height: 3rem;
      margin-bottom: 2rem;
    }

    img {
      max-width: 100%;
      height: auto;
      margin: 0;
      //border-radius: 0.5rem;
    }
  }

  .article_footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 3rem;
    //border-top: 1px solid #e0e0e0;

    .social_share {
      display: flex;
      gap: 2rem;

      .social_link {
        display: inline-block;
        width: 4rem;
        height: 4rem;

        .social_icon {
          width: 100%;
          height: 100%;
          cursor: pointer;
          transition: all 0.3s;
        }

        &:nth-child(1) .social_icon {
          content: url('../../static/img/news_wx_icon.png');
          &:hover {
            content: url('../../static/img/news_wx_icon_blue.png');
          }
        }

        &:nth-child(2) .social_icon {
          content: url('../../static/img/news_fb_icon.png');
          &:hover {
            content: url('../../static/img/news_fb_icon_blue.png');
          }
        }

        &:nth-child(3) .social_icon {
          content: url('../../static/img/news_in_icon.png');
          &:hover {
            content: url('../../static/img/news_in_icon_blue.png');
          }
        }
      }
    }

    .navigation_buttons {
      display: flex;
      gap: 2rem;

      /deep/ .nav_button {
        font-family: medium;
        padding: 1rem 3rem 0.5rem;
        font-size: 2.2rem;
        border: 1px solid #5B6370;
        background: white;
        color: #5B6370;
        border-radius: 3rem;
        transition: all 0.3s;

        &:hover {
          border-color: #9CCF86;
          color: #9CCF86;
          //background: rgba(25, 97, 172, 0.05);
        }
      }
    }
  }
}

// 右侧最新新闻
.latest_news_sidebar {
  width: 35rem;
  flex-shrink: 0;
  background-color: #F5F5F5;
  padding: 4.5rem 1.6rem 0;
  border-radius: 1.6rem;

  .h3 {
    font-size: 3.2rem;
    color: #212121;
    margin: 0 0 2rem;
    font-family: bold;
    text-align: left;
  }

  .news_list {
    display: flex;
    flex-direction: column;

    .news_item {
      overflow: hidden;
      cursor: pointer;
      transition: all 0.3s;
      border-top: 1px solid #BDC0C5;
      padding-top:2rem;

      &:hover {
        //box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        //transform: translateY(-2px);
      }

      .news_image {
        width: 100%;
        height: 20rem;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .image_placeholder {
          width: 100%;
          height: 100%;
          background: #e0e0e0;
        }
      }

      .news_info {
        padding: 2rem 0;
        background-color: #F5F5F5;

        .first-item & {
          padding: 2rem 0;
        }

        &.news_info_only_title {
          padding: 0;

          .news_title {
            margin-bottom: 2rem;
          }
        }

        .news_title {
          font-size: 1.8rem;
          color: #212121;
          line-height: 3rem;
          margin-bottom: 1rem;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: left;
          background-color: #F5F5F5;
          font-family: regular;
        }

        .news_date {
          font-family: light;
          font-size: 1.6rem;
          color: #8A9099;
          margin: 0;
          text-align: left;
        }
      }
    }
  }
}

// 底部联系信息
.bottom_contact_section {
  padding: 8rem 0;
  background: linear-gradient(135deg, #1a4d8f 0%, #2563a8 100%);

  .bottom_contact_content {
    max-width: 140rem;
    margin: 0 auto;
    padding: 0 2rem;

    .h2 {
      font-size: 3.6rem;
      color: white;
      margin-bottom: 4rem;
    }

    .bottom_contact_card {
      background: white;
      border-radius: 1rem;
      padding: 4rem;
      display: flex;
      justify-content: space-around;
      align-items: center;

      .contact_item {
        display: flex;
        align-items: center;
        gap: 2rem;

        i {
          font-size: 3rem;
          color: $textBlueColor;
        }

        .label {
          font-size: 1.3rem;
          color: #999;
          margin: 0 0 0.5rem 0;
          text-transform: uppercase;
          letter-spacing: 0.1rem;
        }

        .value {
          font-size: 1.6rem;
          color: $color2C;
          margin: 0;
          font-weight: 500;
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .main_content_section {
    padding: 4rem 0;

    .main_content_wrapper {
      flex-direction: column;
    }
  }

  .article_detail {
    padding: 3rem;

    .detail_title {
      font-size: 2.4rem;
    }

    .detail_meta {
      flex-direction: column;
      align-items: flex-start;
      gap: 1rem;
    }

    /deep/ .detail_content {
      font-size: 1.4rem;
      line-height: 2.4rem;

      p {
        font-size: 1.4rem;
        line-height: 2.4rem;
      }
    }

    .article_footer {
      flex-direction: column;
      gap: 2rem;
      align-items: flex-start;
    }
  }

  .latest_news_sidebar {
    width: 100%;

    .news_list {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 2rem;
    }
  }

  .bottom_contact_section {
    padding: 4rem 0;

    .bottom_contact_content {
      .h2 {
        font-size: 2.8rem;
      }

      .bottom_contact_card {
        flex-direction: column;
        gap: 3rem;
        align-items: flex-start;
      }
    }
  }
}

@media (max-width: 768px) {
  .breadcrumb_section {
    width: 100%;
    margin-left: 2rem;
    padding: 2rem 0 0;

    .breadcrumb_content {
      font-size: 1.4rem;
      padding: 0;

      span.separator {
        margin: 0 0.5rem;
      }
    }
  }

  .main_content_section {
    padding: 6rem 0 15rem;

    .main_content_wrapper {
      margin: 0 2rem;
      display: flex;
      gap: 2rem;
    }
  }

  .article_detail {
    padding: 0;

    .detail_title {
      font-size: 2.2rem;
      line-height: 3rem;
      margin: 0 0 1.5rem;
    }

    .detail_meta {
      margin-bottom: 2rem;
      display: flex;
      gap: 1.5rem;

      .detail_time {
        font-size: 1.4rem;
      }
    }

    /deep/ .detail_content {
      font-size: 1.6rem;
      line-height: 2.6rem;
      margin-bottom: 4rem;

      p {
        font-size: 1.6rem;
        line-height: 2.6rem;
        margin-bottom: 1.5rem;
      }
    }

    .article_footer {
      flex-direction: row;
      padding-top: 2rem;
      display: flex;

      .social_share {
        display: flex;
        gap: 1.5rem;

        .social_link {
          width: 3rem;
          height: 3rem;
        }
      }

      .navigation_buttons {
        display: flex;
        gap: 1.5rem;

        /deep/ .nav_button {
          padding: 0.8rem 1.4rem 0.4rem;
          font-size: 1.4rem;
        }
      }
    }
  }

  .latest_news_sidebar {
    width: 100%;
    box-sizing: border-box;
    padding: 3rem 1rem;

    .h3 {
      font-size: 2.5rem;
      margin: 0 0 1.5rem;
    }

    .news_list {
      display: flex;

      .news_item {
        padding-top: 1.5rem;

        .news_image {
          height: 15rem;
        }

        .news_info {
          padding: 1.5rem 0;

          .news_title {
            font-size: 1.6rem;
            line-height: 2.4rem;
            margin-bottom: 0.8rem;
          }

          .news_date {
            font-size: 1.4rem;
          }
        }
      }
    }
  }

  .bottom_contact_section {
    padding: 4rem 0;

    .bottom_contact_content {
      padding: 0 1rem;

      .h2 {
        font-size: 2.4rem;
        margin-bottom: 2rem;
      }

      .bottom_contact_card {
        padding: 2rem;

        .contact_item {
          display: flex;
          gap: 1.5rem;
        }
      }
    }
  }
}
</style>
